import React from 'react';
import { EmptyDataIcon } from 'icons';

interface IProps {
  title?: string;
  height?: string;
  desc?: React.ReactNode;
}

const EmptyData: React.FC<IProps> = ({ title, height = 100, desc }) => (
  <div className={`h-${height} flex items-center justify-center sm:col-span-3`}>
    <div className="flex w-full flex-col items-center justify-center">
      <EmptyDataIcon />
      <span className="mt-4 text-gray-500">{title}</span>
      {desc && <span className="text-sm text-gray-400">{desc}</span>}
    </div>
  </div>
);

export default EmptyData;
